"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var Split_exports = {};
__export(Split_exports, {
  default: () => Split_default
});
module.exports = __toCommonJS(Split_exports);
var React = __toESM(require("react"));
var import_styled_components = __toESM(require("styled-components"));
const SvgIcon = ({
  title,
  titleId,
  desc,
  descId,
  iconSize,
  ariaHidden,
  ...props
}) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    ...props,
    viewBox: "0 0 21 20",
    fill: "currentColor",
    color: "currentColor",
    role: "img",
    "aria-labelledby": titleId,
    "aria-describedby": descId
  },
  desc ? /* @__PURE__ */ React.createElement("desc", { id: descId }, desc) : null,
  title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null,
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M17.7852 4.41016C18.0716 4.41016 18.319 4.50781 18.5273 4.70312C18.7357 4.88542 18.8398 5.11328 18.8398 5.38672V15.1133C18.8398 15.3867 18.7357 15.6211 18.5273 15.8164C18.319 15.9987 18.0716 16.0898 17.7852 16.0898H3.21484C2.92839 16.0898 2.68099 15.9987 2.47266 15.8164C2.26432 15.6211 2.16016 15.3867 2.16016 15.1133V5.38672C2.16016 5.11328 2.26432 4.88542 2.47266 4.70312C2.68099 4.50781 2.92839 4.41016 3.21484 4.41016H17.7852ZM14.543 11.6367L14.6016 11.6953C14.6536 11.7734 14.6732 11.8646 14.6602 11.9688C14.6602 12.0599 14.6211 12.1445 14.543 12.2227C14.4648 12.3008 14.3672 12.3398 14.25 12.3398C14.1328 12.3398 14.0352 12.3008 13.957 12.2227L12.2969 10.543L12.2383 10.4844C12.1862 10.4062 12.1602 10.3216 12.1602 10.2305C12.1732 10.1263 12.2188 10.0352 12.2969 9.95703L13.957 8.29688L14.0156 8.23828C14.0938 8.1862 14.1849 8.16667 14.2891 8.17969C14.3932 8.17969 14.4779 8.21875 14.543 8.29688L14.6016 8.35547C14.6536 8.43359 14.6732 8.52474 14.6602 8.62891C14.6602 8.73307 14.6211 8.81771 14.543 8.88281L13.5859 9.83984H18V5.25H3V9.83984H7.39453L6.45703 8.88281C6.37891 8.81771 6.33333 8.73307 6.32031 8.62891C6.32031 8.52474 6.34635 8.43359 6.39844 8.35547L6.45703 8.29688C6.52214 8.21875 6.60677 8.17969 6.71094 8.17969C6.8151 8.16667 6.90625 8.1862 6.98438 8.23828L7.04297 8.29688L8.70312 9.95703C8.78125 10.0352 8.82031 10.1263 8.82031 10.2305C8.83333 10.3216 8.8138 10.4062 8.76172 10.4844L8.70312 10.543L7.04297 12.2227C6.96484 12.3008 6.86719 12.3398 6.75 12.3398C6.63281 12.3398 6.53516 12.3008 6.45703 12.2227C6.37891 12.1445 6.33333 12.0599 6.32031 11.9688C6.32031 11.8646 6.34635 11.7734 6.39844 11.6953L6.45703 11.6367L7.41406 10.6602H3V15.25H18V10.6602H13.5859L14.543 11.6367Z",
      fill: "currentColor"
    }
  )
);
const SvgSplit = (0, import_styled_components.default)(SvgIcon)(({ iconSize, color }) => {
  const getIconSize = () => {
    const standardIconSize = {
      s: "17px",
      // 17px small
      m: "20px",
      // 20px medium
      l: "24px",
      // 24px large
      xl: "32px",
      // 32px extraLarge
      inherit: "inherit"
      // inherits size from parent
    };
    return standardIconSize[iconSize];
  };
  return import_styled_components.css`
    width: ${getIconSize()};
    height: ${getIconSize()};
    display: inline-block;
    color: ${color};
  `;
});
var Split_default = SvgSplit;
